const doc = [({"en":({"js":({"routes":({"admin":({"score_factor_groups_score_factors":({"new_score_factor":"New score factor"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;